// extracted by mini-css-extract-plugin
module.exports = {"footer":"pageFooter__footer","item":"pageFooter__item","item-right":"pageFooter__item-right"};